/**
 * Google Identity Services(GSI) 스크립트는 index.html에서 로드합니다.
 * 이 헬퍼는 초기화 및 버튼 렌더링을 담당합니다.
 */
export function renderGoogleButton(
  container: HTMLElement,
  onCredential: (idToken: string) => void
): boolean {
  const clientId =
    import.meta.env.VITE_GOOGLE_CLIENT_ID ||
    "177437094606-lq787k2rkk5dnhlcd4ao3sia83mr446t.apps.googleusercontent.com";
  if (!window.google?.accounts?.id || !clientId) {
    return false;
  }

  window.google.accounts.id.initialize({
    client_id: clientId,
    callback: (response) => onCredential(response.credential),
  });

  window.google.accounts.id.renderButton(container, {
    type: "standard",
    theme: "outline",
    size: "large",
    shape: "pill",
    width: 320,
    text: "continue_with",
    logo_alignment: "left",
  });

  return true;
}
